export default "__VITE_ASSET__b72897ee__"